// Logger utility that respects environment and log levels
const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  NONE: 4
};

// Get log level from environment or localStorage
const getLogLevel = () => {
  // Allow override via localStorage for debugging in production
  const storedLevel = localStorage.getItem('LOG_LEVEL');
  if (storedLevel) {
    return parseInt(storedLevel, 10);
  }
  
  // In production, only show WARN and ERROR
  if (process.env.NODE_ENV === 'production') {
    return LOG_LEVELS.WARN;
  }
  
  // In development, show all logs
  return LOG_LEVELS.DEBUG;
};

const currentLogLevel = getLogLevel();

const logger = {
  debug: (...args) => {
    if (currentLogLevel <= LOG_LEVELS.DEBUG) {
      console.log('[DEBUG]', ...args);
    }
  },
  
  info: (...args) => {
    if (currentLogLevel <= LOG_LEVELS.INFO) {
      console.log('[INFO]', ...args);
    }
  },
  
  warn: (...args) => {
    if (currentLogLevel <= LOG_LEVELS.WARN) {
      console.warn('[WARN]', ...args);
    }
  },
  
  error: (...args) => {
    if (currentLogLevel <= LOG_LEVELS.ERROR) {
      console.error('[ERROR]', ...args);
    }
  },
  
  // Helper to check if debug logging is enabled
  isDebugEnabled: () => currentLogLevel <= LOG_LEVELS.DEBUG
};

// Expose LOG_LEVELS for programmatic control
logger.LOG_LEVELS = LOG_LEVELS;

export default logger;











